<!--
 * @Description: 学生学习成绩
 * @Author: PF
 * @Date: 2025-10-27 16:22:24
 * @LastEditors: PF
 * @LastEditTime: 2025-11-27 13:43:17
-->
<template>
  <div class="list-page">
    <el-container>
      <el-header>
        <!-- 搜索区域 BEGIN -->
        <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <el-form-item>
            <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change="bindTable()">
              <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable :teleported="false" @change="initZhuanYe();bindTable()">
              <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable :teleported="false" @change="initBanJi();bindTable()">
              <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="年级" v-model="dataGrid.parms.njid" clearable filterable :teleported="false" @change="initBanJi();bindTable()">
              <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="班级" v-model="dataGrid.parms.bjid" clearable filterable :teleported="false" @change="bindTable()">
              <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="学生" v-model="dataGrid.parms.xm" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="网络课程" v-model="dataGrid.parms.wlkcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main>
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
          <el-table-column type="index" label="序号" align="center" width="55" />
          <el-table-column label="学号" prop="xh" min-width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="姓名" prop="xm" min-width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="班级" prop="bjmc" min-width="160" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="课程" prop="kcmc" min-width="180px" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="网络课程" prop="wlkcmc" min-width="180px" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="最终成绩" prop="zzcj" width="110px" align="center" sortable :sort-orders="['ascending', 'descending']" />
        </el-table>
      </el-main>
      <!-- 分页 -->
      <el-footer>
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
      </el-footer>
    </el-container>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, submitDataGridAction, homeCloseWindow, loadSelect, actionPost } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import pingJia from '@/pages/wangluokecheng/wangluokecheng/xueshengxuexijilu/pingJia.vue'

const props = defineProps({ row: { type: Object, required: false } })

const xxztData = ref([
  {value: 0, label: '未开始'},
  {value: 1, label: '进行中'},
  {value: 2, label: '已完成'},
])
const countNotBegin = ref(0)
const countBegin = ref(0)
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.isAll = 0
  loadList({
    url: '/api/v2/wangluojiaoxue/chengji/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      countNotBegin.value =  res.data ? res.data.countNotBegin : 0 //未学习的人数
      countBegin.value =  res.data ? res.data.countBegin : 0 //已开始学习人数
    }
  })
}
const xxjdFormatter = (row) => {
  return row.xxjd + '%'
}
const xxztFormatter = (row) => {
  let info = xxztData.value.find(item => row.xxzt == item.value)
  return info ? info.label : ''
}

// 加载 学期 下拉框
const xqData = ref()
const initXueQi = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          dataGrid.value.parms.xqid = element.id
          bindTable()
        }
      })
    }
  })
}
// 加载 系部 下拉框
const xbData = ref()
loadSelect({ url: '/api/v2/xiaoneijigou/listxibu', data: xbData, order: 'jgh', sort: 'asc' })
// 加载 专业 下拉框
const zyData = ref()
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: {
      xbid: dataGrid.value.parms.xbid,
      ccid: dataGrid.value.parms.ccid
    },
    order: 'zybh',
    sort: 'asc'
  })
}
initZhuanYe()

// 加载 年级 下拉框
const njData = ref()
loadSelect({ url: '/api/v2/pdp/nianji/list', data: njData, order: 'njdm', sort: 'asc' })

// 加载 班级 下拉框
const bjData = ref()
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: bjData,
    parms: {
      zyid: dataGrid.value.parms.zyid,
      njid: dataGrid.value.parms.njid
    },
    order: 'xzbdm',
    sort: 'asc'
  })
}
initBanJi()

// 弹窗
const tcrow = ref({})
const openDetail = ref(false)
const openList = ref(false)

watch(
  () => props.row,
  () => {
    if (props.row) {
      dataGrid.value.parms.lsid = props.row.lsid
    }
    initXueQi()
  },
  { deep: true, immediate: true }
)

</script>
